import PageBanner from "@/components/PageBanner";
import Reveal from "@/components/Reveal";

export default function LegalLayout({ eyebrow, title, subtitle, updated, sections, testId }) {
  return (
    <div data-testid={testId}>
      <PageBanner eyebrow={eyebrow} title={title} subtitle={subtitle} testId={`${testId}-banner`} />
      <section className="mx-auto max-w-3xl px-5 py-16 md:px-8 md:py-24">
        {updated && (
          <p className="mb-12 text-sm text-ink/50">Last updated: {updated}</p>
        )}
        <div className="space-y-12">
          {sections.map((s, i) => (
            <Reveal key={i} delay={i * 0.03}>
              <div>
                <h2 className="font-heading text-2xl text-forest md:text-3xl">{s.heading}</h2>
                {s.body.map((p, j) => (
                  <p key={j} className="mt-4 text-base leading-relaxed text-ink/70">
                    {p}
                  </p>
                ))}
                {s.list && (
                  <ul className="mt-4 space-y-2">
                    {s.list.map((item, k) => (
                      <li key={k} className="flex gap-3 text-base leading-relaxed text-ink/70">
                        <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-sage" />
                        {item}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
